export default function hydrateTime({ stores, services }: CommandArgs) {
  const availabilityStore: AvailabilityStore = stores['availability']
  const bookingFlowStore: BookingFlowStore = stores['program/booking-flow']
  const flowRouter: FlowRouter = services['flow-router']

  function isAnytimeMarker(timeString: string): boolean {
    const normalised = timeString.trim().toLowerCase()
    if (normalised === 'anytime') return true

    const overrideText = bookingFlowStore?.overrideFreesaleText?.trim().toLowerCase()
    return Boolean(overrideText) && normalised === overrideText
  }

  /**
   * Sets the selected time from the ?timeString query param.
   * Skipped if the user (or a prior hydration) has already made an explicit choice — reads the
   * raw `selectedTimeOverride` field, not the derived `selectedAvailabilityTime`, so a HIDDEN-mode
   * auto-selected default (which only ever lives on the derived getter) never blocks hydration.
   * Normalises "anytime" and the program's freesale override text to the canonical "Anytime" string.
   */
  function hydrateFromParams() {
    const timeString = flowRouter.queryParams?.timeString
    if (!timeString || availabilityStore.selectedTimeOverride) return

    availabilityStore.selectedTimeOverride = isAnytimeMarker(timeString) ? 'Anytime' : timeString
    availabilityStore.timeHydratedFromParam = true
  }

  return { hydrateFromParams }
}

declare global {
  export type HydrateTimeCommands = ReturnType<typeof hydrateTime>

  interface CommandRegistry {
    'hydrate/time': HydrateTimeCommands
  }
}
